import { useState, useContext, useEffect, useRef } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button, Calendar, InputText, InputTextarea, classNames } from "primereact";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { Carousel } from "primereact/carousel";
import { Dialog } from "primereact/dialog";

// ------------------ COMPONENTES DE BASE--------------------------------
import AutoCompleteDropdown from "../../../../../../Base/Components/Form/AutoCompleteDropdown";
import Card from "../../../../../../Base/Components/Card/Card";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import Loader from "../../../../../../Base/Components/Loader/Loader";

// ------------------- CONSULTAS A LA API--------------------------------
import { 
  ObtenerSiguienteNoIngresoMateriale, 
  ObtenerSiguienteNoIngresoMP 
} from "../../../../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import RequisasOverlayPanel from "../OverlaysPanels/RequisasOverlayPanel";
import RequisasMaterialesReporte from "../Reporte/RequisasMaterialesReporte";


const EncabezadoRequisasMateriales = ({
  values,
  handleInputChange,
  habilitar,
  setHabilitar,
  resetForm,
  detalles,
  toast,
  setValues,
  getIngreso,
  agregarNuevaFila,
  eliminarItemDetalle,
  setDetalles,
  agentes,
  areas,
  prioridades,
  addOC,
  setMostrarCarousel,
  mostrarCarousel,
  setIngresoToShow,
  guardarRequisa = () => {},
  imagenes = [],
  botonReporteHabilitado,
  MateriaPrima,
  editable,
}) => {
  const { userAuth } = useContext(AuthContext);
  const [NoIngreso, setNoIngreso] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ingesosRequisa, setIngresosRequisa] = useState(false);
  const [selectedPcs, setSelectedPCs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const menuImprimir = useRef(null);
  const [showReporte, setShowReporte] = useState(false);
  const [language, setLanguaje] = useState("es");
  

  const verificarCampos = () => {
    let err = false;

    if (!values.UserNameSolicita) {
      err = true;
      toastShow( toast, "error", "Error", "Debe seleccionar un usuario solicitante.");
    } else if (!values.Area) {
      err = true;
      toastShow(toast, "error", "Error", "Debe seleccionar una Area.");
    } else if (!values?.Priority) {
      err = true;
      toastShow(toast, "error", "Error", "Debe seleccionar una Prioridad.");
    } else if (!values.Comentarios) {
      err = true;
      toastShow(toast, "error", "Error", "Debe ingresar un comentario.");
    }
    return !err;
  };

  const habilitarComponentes = () => {
    setHabilitar(true);
    // if(values?.IdEstado === 29){
    //   setHabilitar(true);
    // }else{
    //   toastShow(toast, "warn", "Advertencia", "Ya existen salidas de esta Requisa.");
    // }
  };

  const close = () => {
    setIngresosRequisa(false);
  };

  // OBTENER VALORES INICIALES PARA CREAR UNA NUEVA REQUISA MATERIAL
  const getInfoNew = async () => {
    setLoading(true);
    const NIngreso = await ObtenerSiguienteNoIngresoMateriale();
    const NIngresoMP = await ObtenerSiguienteNoIngresoMP();

    if(MateriaPrima === 1){
      setNoIngreso(NIngresoMP)
    }else{
      setNoIngreso(NIngreso);
    }

    const NumIngreso = MateriaPrima === 1 ? NIngresoMP[0].Requisa : NIngreso[0].Requisa

    const d = {
      IdEstado: 28,
      StatusName: "Creado",
      FechaEnc: new Date(),
      IdRequisaEnc: -100,
      Requisa: NumIngreso,
      Comentarios: "",
    };
    setTimeout(() => {
      setValues(d);
    }, 300);
    setLoading(false);
  };

  const abrirModal = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const cerrarModal = () => {
    setShowModal(false);
  };

  const items = [
    {
      label: "Ingles",
      icon: "pi pi-file-pdf",
      command: () => {
        setLanguaje("en");
        setShowReporte(true);
      },
    },
    {
      label: "Español",
      icon: "pi pi-file-pdf",
      command: () => {
        setLanguaje("es");
        setShowReporte(true);
      },
    },
  ];

  const nuevoIngreso = () => {
    confirmDialog({
      message: "¿Está seguro que desea crear un nueva requisa de material?",
      header: "Nueva Requisa",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => {
        resetForm();
        setDetalles([]);
        getInfoNew();
        setIngresoToShow(null)
        habilitarComponentes();
        setMostrarCarousel(false);
      },
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  };

  const habilitarEncabezado = () => {
    if(habilitar){
      for (const detalle of detalles) {
        if (detalle.IdEstado !== 29 && detalle?.IdRequisaDet > 0) {
          if (true) {
            return false
          }
        }
      }
    }else{
      return false
    }
  };

  const habilitarEncabezado1 = () => {
    if(habilitar){
      for (const detalle of detalles) {
        if (detalle.IdEstado !== 29 && detalle?.IdRequisaDet > 0) {
          return true;
        }
      }
    }else{
      return true
    }
  };

  useEffect(() =>{
    if(values?.Requisa){
      getIngreso(values?.Requisa)
    }else{
      getInfoNew()
    }
  },[])

  return (
    <div className="form-demo px-3 mb-2 mt-2">
      <div className="d-flex flex-column justify-content-center">
        <Loader loading={loading} />
        <Card
          contenido={
            <div className="d-flex">
              <div className="col-10">
                <div className="d-flex flex-wrap align-items-start gap-3 mt-2">
                  {/* No. Requisa */}
                  <span className="p-inputgroup " style={{ maxWidth: 235 }}>
                    <span className=" field p-float-label">
                      <InputText
                        id="Requisa"
                        name="Requisa"
                        value={values?.Requisa}
                        onChange={handleInputChange}
                        style={{ fontWeight: "bold" }}
                        // onKeyDown={(e) =>
                        //   e.keyCode === 13 ? getIngreso(e) : null
                        // }
                      />
                      <label htmlFor="idEncabezado">{!MateriaPrima ? 'No. Requisa Material' : 'No. Requisa MP'}</label>
                    </span>

                    <Button
                      icon="pi pi-search"
                      type="button"
                      className="p-button-info "
                      onClick={() => getIngreso(values?.Requisa)}
                      tooltip="Buscar Requisa"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                    />
                  </span>

                  {/* Fecha */}
                  <span className="p-float-label">
                    <Calendar
                      id="FechaEnc"
                      name="FechaEnc"
                      disabled
                      value={values?.FechaEnc}
                      dateFormat="dd/mm/yy"
                      mask="99/99/9999"
                      showIcon
                    />
                    <label htmlFor="Date">Fecha Creación</label>
                  </span>

                  {/* Estado */}
                  <span className=" p-float-label">
                    <InputText
                      id="estado"
                      disabled
                      name="estado"
                      value={values?.StatusName}
                      style={{ width: "100%", padding: "6px 3px" }}
                    />
                    <label htmlFor="estado">Estado</label>
                  </span>

                  {/* Usuario */}
                  <span className=" p-float-label">
                    <InputText
                      disabled
                      id="UserCreate"
                      name="UserCreate"
                      readOnly
                      value={values.UserNameCreate || userAuth?.UserName}
                      autoFocus
                      style={{ width: "100%", padding: "6px 3px" }}
                    />
                    <label htmlFor="usuarioCSM">Usuario Creación</label>
                  </span>

                  <AutoCompleteDropdown
                    // enable={habilitar}
                    enable={habilitarEncabezado()}
                    value={values.UserNameSolicita}
                    items={agentes}
                    field={"UserName"}
                    name={"UserNameSolicita"}
                    handleInputChange={handleInputChange}
                    tabIndex={4}
                    label={"Usuario Autoriza"}
                  />

                  <AutoCompleteDropdown
                    // enable={habilitar}
                    enable={habilitarEncabezado()}
                    value={values.Area}
                    items={areas}
                    field={"Area"}
                    name={"Area"}
                    handleInputChange={handleInputChange}
                    tabIndex={4}
                    label={"Area"}
                  />

                  <AutoCompleteDropdown
                    // enable={habilitar}
                    enable={habilitarEncabezado()}
                    name={"Priority"}
                    value={values.Priority}
                    items={prioridades}
                    field={"Priority"}
                    label={"Prioridad"}
                    handleInputChange={handleInputChange}
                  />

                  {/* Comentarios */}
                  <span className=" p-float-label d-flex">
                    <InputTextarea
                      // disabled={!habilitar}
                      disabled={habilitarEncabezado1()}
                      id="Comentarios"
                      name="Comentarios"
                      value={values?.Comentarios}
                      onChange={handleInputChange}
                      cols={86.3}
                      rows={2}
                      className={classNames(" block", "encabezado__contenido")}
                      style={{
                        width: "100%",
                        maxHeight: "3rem",
                        maxWidth: "72vh",
                        height: "3rem",
                      }}
                    />
                    <label
                      id="label_comentario"
                      htmlFor="Comentarios"
                      className={classNames("encabezado__contenido")}
                    >
                      Comentarios
                    </label>
                  </span>
                </div>

                {/* --------------------------BOTONES-----------------------  */}
                <div className="d-flex flex-wrap gap-3 mb-2">
                  <div className="groupEncabezado encabezado__contenido-Card d-flex gap-1 mt-5 flex-wrap justify-content-between">
                    <Button
                      icon="pi pi-plus"
                      disabled={!habilitar}
                      type="button"
                      className="p-button-info encabezado__herramienta-botones"
                      tooltip="Agregar Items"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      onClick={(e) => {
                        if (verificarCampos()) {
                          agregarNuevaFila();
                        }
                      }}
                      tabIndex={7}
                    />
                    <Button
                      icon="pi pi-save"
                      disabled={!habilitar}
                      // disabled={habilitarEncabezado1()}
                      className="p-button-primary encabezado__herramienta-botones"
                      tooltip="Guardar"
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      style={{ marginLeft: 1 }}
                      onClick={(e) => {
                        if (verificarCampos()) {
                          guardarRequisa();
                        }
                      }}
                    />

                    {editable && (
                      <Button
                        icon="pi pi-pencil"
                        type="button"
                        className="p-button-secondary  encabezado__herramienta-botones"
                        onClick={habilitarComponentes}
                        tooltip="Editar"
                        tooltipOptions={{
                          className: "purple-tooltip",
                          position: "top",
                        }}
                        style={{ marginLeft: 1 }}
                      />
                    )}
                    <Button
                      icon="pi pi-times"
                      type="button"
                      className="p-button-danger encabezado__herramienta-botones"
                      onClick={() => eliminarItemDetalle()}
                      tooltip="Cancelar"
                      disabled={!habilitar}
                      tooltipOptions={{
                        className: "purple-tooltip",
                        position: "top",
                      }}
                      style={{ marginLeft: 1 }}
                    />

                    {editable && (
                      <Button
                        icon="pi pi-book"
                        type="button"
                        onClick={nuevoIngreso}
                        tooltip="Nuevo"
                        tooltipOptions={{position: "top"}}
                        style={{ marginLeft: 1 }}
                      />
                    )}

                    {editable && (
                      <Button
                        icon="pi pi-sync"
                        type="button"
                        onClick={() => getIngreso()}
                        tooltip="Cargar"
                        tooltipOptions={{position: "top"}}
                        style={{ marginLeft: 1 }}
                      />
                    )}

                    <Button
                      icon="pi pi-print"
                      disabled={!botonReporteHabilitado}
                      tooltip="Imprimir"
                      tooltipOptions={{ position: "top" }}
                      onClick={(e) => {
                        console.log("CLICK IMPRIMIR MODAL");
                        console.log("Menu ref:", menuImprimir.current);
                        console.log("Requisa:", values?.Requisa);
                        console.log("botonReporteHabilitado:", botonReporteHabilitado);

                        menuImprimir.current.toggle(e);
                      }}
                    />
                    <Menu model={items} popup ref={menuImprimir} appendTo={document.body}/>

                    {
                      <RequisasOverlayPanel
                        setNuevaFila={addOC}
                        close={close}
                        selectedPcs={selectedPcs}
                        setSelectedPCs={setSelectedPCs}
                        verificarCampos={verificarCampos}
                        habilitar={habilitar}
                        MateriaPrima={MateriaPrima}
                      />
                    }
                  </div>
                </div>
              </div>

              {mostrarCarousel && (
                <div
                  className="col-2 d-flex mt-3"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      overflow: "hidden"
                    }}
                  >
                    {imagenes.CodigoProducto && (
                      <Carousel
                        value={imagenes.img}
                        circular
                        showIndicators={false}
                        itemTemplate={(item) => {
                          return (
                            <div
                              className="d-flex"
                              style={{
                                justifyContent: "center",
                                alignItems: "center",
                                height: "150px",
                              }}
                            >
                              <img
                                src={"data:image/png;base64," + item}
                                alt="imagen"
                                onClick={() => abrirModal(item)}
                                style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", cursor: "pointer" }}
                              />
                            </div>
                          );
                        }}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          }
        />
      </div>

      {/* Dialogo para mostrar imagenes */}
      <Dialog header={imagenes ? imagenes?.NombreProducto : ""} visible={showModal} onHide={cerrarModal} className="w-50">
        <div>
          {imagenes.CodigoProducto && (
            <Carousel
              value={imagenes.img}
              circular
              showIndicators={true}
              itemTemplate={(item) => {
                return (
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      height: "600px",
                    }}
                  >
                    <img
                      src={"data:image/png;base64," + item}
                      alt="imagen"
                      style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                    />
                  </div>
                );
              }}
            />
          )}
        </div>
      </Dialog>

      {showReporte && (
      <RequisasMaterialesReporte
        showReporte={showReporte}
        setShowReporte={setShowReporte}
        IdRequisaM={values?.Requisa}
        Idioma={language === "en" ? 1 : 2}
      />
    )}
    </div>
  );
};

export default EncabezadoRequisasMateriales;
